package components.routing

import pages.deliveries.DeliveryDetailedPage
import pages.deliveries.DeliveryListPage
import pages.inbound.InboundDetailPage
import pages.inbound.InboundListPage
import pages.landing.LandingPage
import pages.outbound.OutboundListPage
import pages.outbound.OutboundOrderDetailedPage
import pages.stock.StockListPage
import react.FC
import react.create
import react.router.Route
import react.router.Routes

val ProtectedRouting = FC<ProtectedRoutingProps>("ProtectedRouting") { props ->
    Routes {
        Route {
            index = true
            path = "*"
            element = LandingPage.create {
                session = props.session
                sessionSetter = props.sessionSetter
                darkMode = props.darkMode
            }
        }

        Route {
            path = ApplicationRoutingUrls.Protected.stockListPage
            element = StockListPage.create {
                session = props.session
                sessionSetter = props.sessionSetter
                darkMode = props.darkMode
            }
        }

        Route {
            path = ApplicationRoutingUrls.Protected.inboundListPage
            element = InboundListPage.create {
                session = props.session
                sessionSetter = props.sessionSetter
                darkMode = props.darkMode
            }
        }

        Route {
            path = ApplicationRoutingUrls.Protected.inboundDetailPage
            element = InboundDetailPage.create {
                session = props.session
                sessionSetter = props.sessionSetter
                darkMode = props.darkMode
            }
        }

        Route {
            path = ApplicationRoutingUrls.Protected.outboundListPage
            element = OutboundListPage.create {
                session = props.session
                sessionSetter = props.sessionSetter
                darkMode = props.darkMode
            }
        }

        Route {
            path = ApplicationRoutingUrls.Protected.outboundDetailPage
            element = OutboundOrderDetailedPage.create {
                session = props.session
                sessionSetter = props.sessionSetter
                darkMode = props.darkMode
            }
        }

        Route {
            path = ApplicationRoutingUrls.Protected.deliveriesListPage
            element = DeliveryListPage.create {
                session = props.session
                sessionSetter = props.sessionSetter
                darkMode = props.darkMode
            }
        }
        Route {
            path = ApplicationRoutingUrls.Protected.deliveryDetailedPage
            element = DeliveryDetailedPage.create {
                session = props.session
                sessionSetter = props.sessionSetter
                darkMode = props.darkMode
            }
        }
    }
}